import config from "@/config";
import http from "@/utils/request";

export default {
	collegeCategory: {
		list: {
			url: `${config.API_URL}/admin/college_category/list`,
			name: "获取分类列表（分页）",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		getAll: {
			url: `${config.API_URL}/admin/college_category/getAll`,
			name: "获取所有分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		tree: {
			url: `${config.API_URL}/admin/college_category/tree`,
			name: "获取树形分类列表",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/college_category/detail`,
			name: "获取分类详情",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		create: {
			url: `${config.API_URL}/admin/college_category/create`,
			name: "创建分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/college_category/update`,
			name: "更新分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/college_category/delete`,
			name: "删除分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		batchDelete: {
			url: `${config.API_URL}/admin/college_category/batch-delete`,
			name: "批量删除分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
};
